import React,{useEffect, useState} from 'react'; 
import HeroSection from '../../Components/Main/Common/HeroSection';
import ContentRow from '../../Components/Main/Common/ContentRow';
import '../../CSS/main.scss';
import ExploreImage from '../../Images/explore_section.jpg';
import LoveMistake from '../../Images/challenge.jpg';
// import HeroImage from '../../Images/chiran_tonmoy.jpeg';
import HomeFooter from '../../Components/Main/Home/HomeFooter';
import getUrl from '../../Utility/GetUrl';
import { fetchData } from '../../Utility/GlobalService';
// import LoadingContext from '../../Components/Main/context/LoadingContext';
import {Dots} from 'react-preloaders2';


const Home = ()=> { 
  const [loading,setLoading] = useState(true);
  const [homeData,setHomeData] = useState([]);
  const [exploreData,setExploreData] = useState([]);
  const [mistakesData,setMistakesData] = useState([]);
  const [footerData,setFooterData] = useState([]);
  useEffect(()=>{
    getHomeData();
    getExploreData();
    getMistakeData();
    getFooterData();
    setLoading(false);
    // console.log(loading);
  },[])
  const getHomeData = async()=>{
    const response = await fetchData(`${getUrl()}/home/getall`);
    setHomeData(response);
  }
  const getExploreData = async()=>{
    const response = await fetchData(`${getUrl()}/explore`);
    setExploreData(response);
  }
  const getMistakeData = async()=>{
    const response = await fetchData(`${getUrl()}/mistakes`);
    setMistakesData(response);
  }
  const getFooterData = async()=>{
    const response = await fetchData(`${getUrl()}/homefooter`);
    setFooterData(response);
    // console.log(response);
  }
  const objectData = [
    {
      title: "LOVE TO EXPLORE",
      content: `I have always been attached with 
      technologies. Since my childhood
      my interest was always inside of
      technology magazines. Since then 
      i always seek for more knowledge
      to learn from new technology and 
      love to experiment with new 
      technology.`,
      image: `${ExploreImage}`
    },
    {
      title: "LOVE MISTAKES",
      content: `Always try to make my work
      perfect. In this case mistakes
      help me more to grow and be 
      careful next time. Mistakes are
      meant to improve ourself not 
      to demotivate.`,
      image: `${LoveMistake}`
    }
  ];
  const heroSectionContent = {
    title: "SIMPLE YET LOVEABLE",
    content: `TONMOY CHIRAN, A SOFTWARE ENGINERR 
    GRADUATE FROM DHAKA, BANGLADESH`
  }
  return (
    
    <div className="home-page">
      <Dots background="#000" color="#00FFA5" customLoading={loading}/>
        <div className="hero-section-container">
          {(homeData)? (<HeroSection data={homeData}/>): (<HeroSection data={[]}/>)}
        </div>
        <div className="explore-section-container">
            <div className="explore-row">
              {(exploreData)? (<ContentRow data={exploreData}/>): (<ContentRow data={[]}/>)}
              {(mistakesData)? (<ContentRow data={mistakesData} rightAlign={false}/>): (<ContentRow data={[]}/>)}
            </div>
        </div>
        <div className="footer">
          {(footerData)? (<HomeFooter data={footerData}/>): (<HomeFooter data={[]}/>)}
        </div>
    </div>
  );
}

export default Home; 